(function () {
  'use strict';

  /* =========================================================
     KONHILL QUICK ADD UPSELL
     - Dynamic product variants
     - US / UK / EU size display
     - AJAX add to cart
     - NO redirect
     - NO cart drawer auto-open
  ========================================================= */


  /* =========================================================
     ROOT
  ========================================================= */

  const root =
    document.getElementById('khq-upsell');

  const modal =
    document.getElementById('khq-modal');


  if (!root || !modal) {
    return;
  }


  if (root.dataset.khqInitialized === 'true') {
    return;
  }


  root.dataset.khqInitialized = 'true';



  /* =========================================================
     ELEMENTS
  ========================================================= */

  const closeButton =
    modal.querySelector('.khq-close');

  const backdrop =
    modal.querySelector('.khq-backdrop');

  const modalTitle =
    document.getElementById('khq-modal-title');

  const modalImage =
    document.getElementById('khq-modal-image');

  const modalPrice =
    document.getElementById('khq-modal-price');

  const comparePrice =
    document.getElementById('khq-compare-price');

  const selectedSummary =
    document.getElementById('khq-selected-summary');

  const optionsContainer =
    document.getElementById('khq-options');

  const addButton =
    document.getElementById('khq-modal-add');

  const addText =
    document.getElementById('khq-add-text');

  const errorBox =
    document.getElementById('khq-error');


  if (
    !closeButton ||
    !backdrop ||
    !modalTitle ||
    !modalImage ||
    !modalPrice ||
    !comparePrice ||
    !selectedSummary ||
    !optionsContainer ||
    !addButton ||
    !addText ||
    !errorBox
  ) {

    console.warn(
      'KONHILL Upsell: required modal elements are missing.'
    );

    return;
  }



  /* =========================================================
     MOVE MODAL TO BODY

     Prevent Shopify theme containers from clipping modal.
  ========================================================= */

  if (modal.parentElement !== document.body) {
    document.body.appendChild(modal);
  }



  /* =========================================================
     STATE
  ========================================================= */

  let activeProduct = null;

  let selectedOptions = [];

  let sizeConversionRows = [];

  let activeSizeRegion = 'US';

  let isAdding = false;

  let lastFocusedElement = null;



  /* =========================================================
     CURRENCY
  ========================================================= */

  const currency =
    (
      window.Shopify &&
      window.Shopify.currency &&
      window.Shopify.currency.active
    )
      ? window.Shopify.currency.active
      : 'USD';


  function formatMoney(cents) {

    const amount =
      Number(cents || 0) / 100;


    try {

      return new Intl.NumberFormat(
        document.documentElement.lang || 'en-US',
        {
          style: 'currency',
          currency: currency
        }
      ).format(amount);

    } catch (error) {

      return amount.toFixed(2);

    }

  }



  /* =========================================================
     BASIC TEXT HELPERS
  ========================================================= */

  function cleanText(value) {

    return String(
      value == null
        ? ''
        : value
    ).trim();

  }


  function normalizedKey(value) {

    return cleanText(value)
      .toLowerCase()
      .replace(/[\s_-]+/g, '')
      .replace(/[^a-z0-9]/g, '');

  }


  function cleanSize(value) {

    return cleanText(value)
      .replace(
        /^(US|UK|EU|EUR)\s*[:\-\/]?\s*/i,
        ''
      )
      .replace(/\s+/g, ' ')
      .toLowerCase();

  }



  /* =========================================================
     DETECT SIZE OPTION
  ========================================================= */

  function isSizeOption(optionName) {

    const key =
      normalizedKey(optionName);


    return (
      key === 'size' ||
      key.includes('size')
    );

  }



  /* =========================================================
     CASE-INSENSITIVE OBJECT VALUE
  ========================================================= */

  function getObjectValue(
    object,
    possibleKeys
  ) {

    if (
      !object ||
      typeof object !== 'object' ||
      Array.isArray(object)
    ) {

      return null;

    }


    const objectKeys =
      Object.keys(object);


    const normalizedCandidates =
      possibleKeys.map(normalizedKey);


    const foundKey =
      objectKeys.find(
        function (key) {

          return normalizedCandidates.includes(
            normalizedKey(key)
          );

        }
      );


    if (!foundKey) {
      return null;
    }


    return object[foundKey];

  }



  /* =========================================================
     SIZE REGION KEY NAMES

     Allows metafield JSON fields such as:

     US
     us
     US Size
     us_size
     size_us

     etc.
  ========================================================= */

  function getRegionKeys(region) {

    if (region === 'US') {

      return [
        'US',
        'us',
        'US Size',
        'us size',
        'USSize',
        'us_size',
        'size_us',
        'sizeUS'
      ];

    }


    if (region === 'UK') {

      return [
        'UK',
        'uk',
        'UK Size',
        'uk size',
        'UKSize',
        'uk_size',
        'size_uk',
        'sizeUK'
      ];

    }


    return [
      'EU',
      'eu',
      'EUR',
      'eur',
      'EU Size',
      'eu size',
      'EUR Size',
      'EUSize',
      'eu_size',
      'eur_size',
      'size_eu',
      'size_eur',
      'sizeEU'
    ];

  }



  function getRegionValue(
    object,
    region
  ) {

    return getObjectValue(
      object,
      getRegionKeys(region)
    );

  }



  /* =========================================================
     NORMALIZE ONE SIZE ROW
  ========================================================= */

  function normalizeSizeRow(
    row,
    fallbackUS
  ) {

    if (
      !row ||
      typeof row !== 'object' ||
      Array.isArray(row)
    ) {

      return null;

    }


    let us =
      getRegionValue(
        row,
        'US'
      );


    const uk =
      getRegionValue(
        row,
        'UK'
      );


    const eu =
      getRegionValue(
        row,
        'EU'
      );


    if (
      (us == null || us === '') &&
      fallbackUS != null
    ) {

      us =
        fallbackUS;

    }


    if (
      us == null &&
      uk == null &&
      eu == null
    ) {

      return null;

    }


    return {
      US: us,
      UK: uk,
      EU: eu
    };

  }



  /* =========================================================
     SIZE CONVERSION DATA PARSER

     Supports:

     FORMAT A

     [
       {
         "US": "7",
         "UK": "4.5",
         "EU": "37.5"
       }
     ]


     FORMAT B

     {
       "US": ["7","7.5"],
       "UK": ["4.5","5"],
       "EU": ["37.5","38"]
     }


     FORMAT C

     {
       "sizes": [
         ...
       ]
     }


     FORMAT D

     {
       "7": {
         "UK": "4.5",
         "EU": "37.5"
       }
     }
  ========================================================= */

  function normalizeSizeData(rawData) {

    if (
      rawData == null ||
      rawData === ''
    ) {

      return [];

    }


    let raw =
      rawData;



    /* ---------------------------------------------------------
       STRING JSON
    --------------------------------------------------------- */

    if (typeof raw === 'string') {

      try {

        raw =
          JSON.parse(raw);

      } catch (error) {

        console.warn(
          'KONHILL Upsell: Size Conversion Data is not valid JSON.',
          raw
        );

        return [];

      }

    }



    /* ---------------------------------------------------------
       ARRAY OF OBJECTS
    --------------------------------------------------------- */

    if (Array.isArray(raw)) {

      const rows =
        raw
          .map(
            function (row) {

              return normalizeSizeRow(
                row
              );

            }
          )
          .filter(Boolean);


      if (rows.length) {

        return rows;

      }

    }



    if (
      !raw ||
      typeof raw !== 'object' ||
      Array.isArray(raw)
    ) {

      return [];

    }



    /* ---------------------------------------------------------
       COLUMN ARRAYS

       {
         US: [],
         UK: [],
         EU: []
       }
    --------------------------------------------------------- */

    const usColumn =
      getObjectValue(
        raw,
        getRegionKeys('US')
      );


    const ukColumn =
      getObjectValue(
        raw,
        getRegionKeys('UK')
      );


    const euColumn =
      getObjectValue(
        raw,
        getRegionKeys('EU')
      );


    if (
      Array.isArray(usColumn) ||
      Array.isArray(ukColumn) ||
      Array.isArray(euColumn)
    ) {

      const maxLength =
        Math.max(

          Array.isArray(usColumn)
            ? usColumn.length
            : 0,

          Array.isArray(ukColumn)
            ? ukColumn.length
            : 0,

          Array.isArray(euColumn)
            ? euColumn.length
            : 0

        );


      const rows = [];


      for (
        let i = 0;
        i < maxLength;
        i += 1
      ) {

        rows.push({

          US:
            Array.isArray(usColumn)
              ? usColumn[i]
              : null,

          UK:
            Array.isArray(ukColumn)
              ? ukColumn[i]
              : null,

          EU:
            Array.isArray(euColumn)
              ? euColumn[i]
              : null

        });

      }


      return rows.filter(
        function (row) {

          return (
            row.US != null ||
            row.UK != null ||
            row.EU != null
          );

        }
      );

    }



    /* ---------------------------------------------------------
       NESTED DATA
    --------------------------------------------------------- */

    const nestedKeys = [

      'sizes',

      'sizeData',

      'size_data',

      'rows',

      'data',

      'conversion',

      'conversions',

      'sizeConversion',

      'size_conversion',

      'sizeConversionData',

      'size_conversion_data'

    ];


    for (
      const key of nestedKeys
    ) {

      const nested =
        getObjectValue(
          raw,
          [key]
        );


      if (nested != null) {

        const result =
          normalizeSizeData(
            nested
          );


        if (result.length) {

          return result;

        }

      }

    }



    /* ---------------------------------------------------------
       KEYED BY US SIZE

       {
         "7": {
           UK: "4.5",
           EU: "37.5"
         }
       }
    --------------------------------------------------------- */

    const keyedRows = [];


    Object.keys(raw).forEach(
      function (key) {

        const row =
          normalizeSizeRow(
            raw[key],
            key
          );


        if (row) {

          keyedRows.push(
            row
          );

        }

      }
    );


    return keyedRows;

  }



  /* =========================================================
     FIND SIZE CONVERSION ROW
  ========================================================= */

  function findSizeRow(
    originalSize
  ) {

    if (!sizeConversionRows.length) {
      return null;
    }


    const target =
      cleanSize(
        originalSize
      );



    /* ---------------------------------------------------------
       First assume Shopify Variant uses US size
    --------------------------------------------------------- */

    let found =
      sizeConversionRows.find(
        function (row) {

          return (
            cleanSize(row.US)
            === target
          );

        }
      );


    if (found) {

      return found;

    }



    /* ---------------------------------------------------------
       Fallback:
       Shopify Variant might use UK/EU as base
    --------------------------------------------------------- */

    found =
      sizeConversionRows.find(
        function (row) {

          return (

            cleanSize(row.US)
              === target

            ||

            cleanSize(row.UK)
              === target

            ||

            cleanSize(row.EU)
              === target

          );

        }
      );


    return found || null;

  }



  /* =========================================================
     CONVERT SIZE FOR DISPLAY
  ========================================================= */

  function convertSize(
    originalSize,
    region
  ) {

    const row =
      findSizeRow(
        originalSize
      );


    if (!row) {

      return originalSize;

    }


    const converted =
      row[region];


    if (
      converted == null ||
      converted === ''
    ) {

      return originalSize;

    }


    return String(
      converted
    );

  }



  /* =========================================================
     DISPLAY OPTION VALUE
  ========================================================= */

  function displayOptionValue(
    optionIndex,
    originalValue
  ) {

    if (!activeProduct) {

      return originalValue;

    }


    const optionName =
      activeProduct.options[
        optionIndex
      ];


    if (
      isSizeOption(
        optionName
      )
    ) {

      return convertSize(
        originalValue,
        activeSizeRegion
      );

    }


    return originalValue;

  }



  /* =========================================================
     FIND CURRENT VARIANT

     IMPORTANT:
     selectedOptions always stores Shopify's ORIGINAL
     option values.

     US/UK/EU does not change this.
  ========================================================= */

  function getCurrentVariant() {

    if (!activeProduct) {

      return null;

    }


    return (
      activeProduct.variants.find(
        function (variant) {

          return variant.options.every(
            function (
              value,
              index
            ) {

              return (
                value ===
                selectedOptions[index]
              );

            }
          );

        }
      )
      ||
      null
    );

  }



  /* =========================================================
     OPTION AVAILABILITY
  ========================================================= */

  function isOptionAvailable(
    optionIndex,
    optionValue
  ) {

    if (!activeProduct) {

      return false;

    }


    return activeProduct.variants.some(
      function (variant) {

        if (!variant.available) {

          return false;

        }


        if (
          variant.options[
            optionIndex
          ]
          !== optionValue
        ) {

          return false;

        }



        /* -----------------------------------------------------
           Match all selections before this option
        ----------------------------------------------------- */

        for (
          let index = 0;
          index < optionIndex;
          index += 1
        ) {

          if (
            variant.options[index]
            !== selectedOptions[index]
          ) {

            return false;

          }

        }


        return true;

      }
    );

  }



  /* =========================================================
     FIX FOLLOWING OPTIONS AFTER CHANGING ONE

     Example:

     Customer changes Color
     ↓
     Current Size is not available in new Color
     ↓
     Automatically choose first valid Size
  ========================================================= */

  function normalizeFollowingOptions(
    changedIndex
  ) {

    if (!activeProduct) {

      return;

    }


    for (
      let optionIndex =
        changedIndex + 1;

      optionIndex <
        activeProduct.options.length;

      optionIndex += 1
    ) {


      const compatibleVariants =
        activeProduct.variants.filter(
          function (variant) {

            if (!variant.available) {

              return false;

            }


            for (
              let previousIndex = 0;
              previousIndex < optionIndex;
              previousIndex += 1
            ) {

              if (
                variant.options[
                  previousIndex
                ]
                !==
                selectedOptions[
                  previousIndex
                ]
              ) {

                return false;

              }

            }


            return true;

          }
        );


      const validValues =
        [
          ...new Set(
            compatibleVariants.map(
              function (variant) {

                return variant.options[
                  optionIndex
                ];

              }
            )
          )
        ];


      if (
        !validValues.includes(
          selectedOptions[
            optionIndex
          ]
        )
      ) {

        selectedOptions[
          optionIndex
        ] =
          validValues[0] || '';

      }

    }

  }



  /* =========================================================
     UPDATE OPTION BUTTONS
  ========================================================= */

  function updateOptionButtons() {

    modal
      .querySelectorAll(
        '.khq-option-button'
      )
      .forEach(
        function (button) {

          const optionIndex =
            Number(
              button.dataset.optionIndex
            );


          const originalValue =
            button.dataset.optionValue;


          const selected =
            selectedOptions[
              optionIndex
            ] === originalValue;


          button.classList.toggle(
            'is-selected',
            selected
          );


          button.setAttribute(
            'aria-pressed',
            selected
              ? 'true'
              : 'false'
          );


          button.disabled =
            !isOptionAvailable(
              optionIndex,
              originalValue
            );


          /* ---------------------------------------------------
             Change displayed Size to US/UK/EU
          --------------------------------------------------- */

          button.textContent =
            displayOptionValue(
              optionIndex,
              originalValue
            );

        }
      );



    /* ---------------------------------------------------------
       Update selected Color / Fit labels
    --------------------------------------------------------- */

    modal
      .querySelectorAll(
        '.khq-option-selected'
      )
      .forEach(
        function (label) {

          const optionIndex =
            Number(
              label.dataset.optionIndex
            );


          label.textContent =
            displayOptionValue(
              optionIndex,
              selectedOptions[
                optionIndex
              ]
            );

        }
      );

  }



  /* =========================================================
     UPDATE SELECTED SUMMARY
  ========================================================= */

  function updateSelectedSummary() {

    if (!activeProduct) {

      selectedSummary.textContent =
        '';

      return;

    }


    const values =
      selectedOptions.map(
        function (
          originalValue,
          index
        ) {

          const optionName =
            activeProduct.options[
              index
            ];


          const displayValue =
            displayOptionValue(
              index,
              originalValue
            );


          if (
            isSizeOption(
              optionName
            )
          ) {

            return (
              activeSizeRegion +
              ' ' +
              displayValue
            );

          }


          return displayValue;

        }
      );


    selectedSummary.textContent =
      values
        .filter(Boolean)
        .join(' / ');

  }



  /* =========================================================
     UPDATE VARIANT IMAGE / PRICE
  ========================================================= */

  function updateVariantInformation() {

    const variant =
      getCurrentVariant();


    if (
      !variant ||
      !variant.available
    ) {

      addButton.disabled =
        true;


      addText.textContent =
        'UNAVAILABLE';


      return;

    }



    /* ---------------------------------------------------------
       PRICE
    --------------------------------------------------------- */

    modalPrice.textContent =
      formatMoney(
        variant.price
      );



    /* ---------------------------------------------------------
       COMPARE PRICE
    --------------------------------------------------------- */

    if (
      variant.compare_at_price &&
      Number(
        variant.compare_at_price
      )
      >
      Number(
        variant.price
      )
    ) {

      comparePrice.textContent =
        formatMoney(
          variant.compare_at_price
        );

    } else {

      comparePrice.textContent =
        '';

    }



    /* ---------------------------------------------------------
       IMAGE
    --------------------------------------------------------- */

    if (variant.image) {

      modalImage.src =
        variant.image;

    } else if (
      activeProduct.featured_image
    ) {

      modalImage.src =
        activeProduct.featured_image;

    }



    /* ---------------------------------------------------------
       BUTTON
    --------------------------------------------------------- */

    addButton.disabled =
      false;


    addText.textContent =
      'ADD TO CART';

  }



  /* =========================================================
     UPDATE ENTIRE MODAL
  ========================================================= */

  function updateModal() {

    updateOptionButtons();

    updateSelectedSummary();

    updateVariantInformation();

  }



  /* =========================================================
     BUILD US / UK / EU DROPDOWN
  ========================================================= */

  function buildSizeRegionSelector(
    headerElement
  ) {

    const right =
      document.createElement(
        'div'
      );


    right.className =
      'khq-size-header-right';



    const wrapper =
      document.createElement(
        'div'
      );


    wrapper.className =
      'khq-size-region-wrap';



    const select =
      document.createElement(
        'select'
      );


    select.className =
      'khq-size-region';


    select.setAttribute(
      'aria-label',
      'Choose size system'
    );



    [
      'US',
      'UK',
      'EU'
    ].forEach(
      function (region) {

        const option =
          document.createElement(
            'option'
          );


        option.value =
          region;


        option.textContent =
          region;


        option.selected =
          (
            region ===
            activeSizeRegion
          );


        select.appendChild(
          option
        );

      }
    );



    select.addEventListener(
      'change',
      function () {

        /*
          IMPORTANT:

          Only change the displayed size.

          selectedOptions still contains
          original Shopify Variant values.
        */

        activeSizeRegion =
          select.value;


        updateModal();

      }
    );



    const arrow =
      document.createElement(
        'span'
      );


    arrow.className =
      'khq-size-region-arrow';


    arrow.setAttribute(
      'aria-hidden',
      'true'
    );



    wrapper.appendChild(
      select
    );


    wrapper.appendChild(
      arrow
    );


    right.appendChild(
      wrapper
    );


    headerElement.appendChild(
      right
    );

  }



  /* =========================================================
     BUILD PRODUCT OPTIONS

     Dynamically supports:

     Color
     Size
     Fit
     Material
     Width
     etc.
  ========================================================= */

  function buildOptions() {

    optionsContainer.innerHTML =
      '';


    if (
      !activeProduct ||
      !Array.isArray(
        activeProduct.options
      )
    ) {

      return;

    }



    /* ---------------------------------------------------------
       PRODUCT WITH ONLY DEFAULT TITLE
    --------------------------------------------------------- */

    const defaultOnly =
      (
        activeProduct.options.length === 1
      )
      &&
      (
        normalizedKey(
          activeProduct.options[0]
        )
        ===
        'title'
      )
      &&
      activeProduct.variants.every(
        function (variant) {

          return (
            cleanText(
              variant.options[0]
            )
            ===
            'Default Title'
          );

        }
      );


    if (defaultOnly) {

      return;

    }



    activeProduct.options.forEach(
      function (
        optionName,
        optionIndex
      ) {

        const sizeOption =
          isSizeOption(
            optionName
          );



        /* -----------------------------------------------------
           GROUP
        ----------------------------------------------------- */

        const group =
          document.createElement(
            'div'
          );


        group.className =
          'khq-option-group';



        /* -----------------------------------------------------
           HEADER
        ----------------------------------------------------- */

        const header =
          document.createElement(
            'div'
          );


        header.className =
          'khq-option-header';



        const optionTitle =
          document.createElement(
            'span'
          );


        optionTitle.className =
          'khq-option-name';


        optionTitle.textContent =
          optionName;



        header.appendChild(
          optionTitle
        );



        /* -----------------------------------------------------
           SIZE

           SIZE                   [US ▼]
        ----------------------------------------------------- */

        if (sizeOption) {

          buildSizeRegionSelector(
            header
          );

        }



        /* -----------------------------------------------------
           COLOR / FIT ETC.

           COLOR                  Beige
        ----------------------------------------------------- */

        else {

          const selectedLabel =
            document.createElement(
              'span'
            );


          selectedLabel.className =
            'khq-option-selected';


          selectedLabel.dataset.optionIndex =
            String(
              optionIndex
            );


          header.appendChild(
            selectedLabel
          );

        }



        /* -----------------------------------------------------
           OPTION VALUES
        ----------------------------------------------------- */

        const valuesContainer =
          document.createElement(
            'div'
          );


        valuesContainer.className =
          'khq-option-values';



        const uniqueValues =
          [
            ...new Set(
              activeProduct.variants.map(
                function (variant) {

                  return variant.options[
                    optionIndex
                  ];

                }
              )
            )
          ];



        uniqueValues.forEach(
          function (originalValue) {

            const button =
              document.createElement(
                'button'
              );


            button.type =
              'button';


            button.className =
              'khq-option-button';


            if (sizeOption) {

              button.classList.add(
                'khq-size-button'
              );

            }



            /*
              IMPORTANT

              data-option-value ALWAYS contains
              ORIGINAL Shopify Variant value.

              Example:

              Shopify Variant:
              Size = 7

              US displays 7
              UK displays 4.5
              EU displays 37.5

              But internally:
              data-option-value = "7"
            */

            button.dataset.optionIndex =
              String(
                optionIndex
              );


            button.dataset.optionValue =
              originalValue;


            button.setAttribute(
              'aria-pressed',
              'false'
            );


            button.textContent =
              displayOptionValue(
                optionIndex,
                originalValue
              );



            button.addEventListener(
              'click',
              function () {

                if (button.disabled) {

                  return;

                }


                selectedOptions[
                  optionIndex
                ] =
                  originalValue;


                normalizeFollowingOptions(
                  optionIndex
                );


                updateModal();

              }
            );



            valuesContainer.appendChild(
              button
            );

          }
        );



        group.appendChild(
          header
        );


        group.appendChild(
          valuesContainer
        );


        optionsContainer.appendChild(
          group
        );

      }
    );

  }



  /* =========================================================
     READ PRODUCT JSON
  ========================================================= */

  function readProductData(
    scriptId
  ) {

    const script =
      document.getElementById(
        scriptId
      );


    if (!script) {

      console.warn(
        'KONHILL Upsell: product data not found:',
        scriptId
      );


      return null;

    }


    try {

      return JSON.parse(
        script.textContent
      );

    } catch (error) {

      console.error(
        'KONHILL Upsell: invalid product JSON.',
        error
      );


      return null;

    }

  }



  /* =========================================================
     OPEN MODAL
  ========================================================= */

  function openModal(
    productJsonId
  ) {

    const productData =
      readProductData(
        productJsonId
      );


    if (
      !productData ||
      !Array.isArray(
        productData.variants
      ) ||
      !productData.variants.length
    ) {

      return;

    }



    activeProduct =
      productData;



    /* ---------------------------------------------------------
       READ THIS PRODUCT'S SIZE CONVERSION DATA
    --------------------------------------------------------- */

    sizeConversionRows =
      normalizeSizeData(
        activeProduct.size_conversion
      );



    /* ---------------------------------------------------------
       DEFAULT SIZE SYSTEM
    --------------------------------------------------------- */

    activeSizeRegion =
      'US';



    /* ---------------------------------------------------------
       FIRST AVAILABLE VARIANT
    --------------------------------------------------------- */

    const firstVariant =
      activeProduct.variants.find(
        function (variant) {

          return variant.available;

        }
      )
      ||
      activeProduct.variants[0];



    if (!firstVariant) {

      return;

    }



    /* ---------------------------------------------------------
       ORIGINAL SHOPIFY OPTION VALUES
    --------------------------------------------------------- */

    selectedOptions =
      firstVariant.options.slice();



    /* ---------------------------------------------------------
       PRODUCT INFO
    --------------------------------------------------------- */

    modalTitle.textContent =
      activeProduct.title || '';


    modalImage.alt =
      activeProduct.title || '';


    if (
      firstVariant.image
    ) {

      modalImage.src =
        firstVariant.image;

    } else if (
      activeProduct.featured_image
    ) {

      modalImage.src =
        activeProduct.featured_image;

    } else {

      modalImage.removeAttribute(
        'src'
      );

    }



    /* ---------------------------------------------------------
       ERROR RESET
    --------------------------------------------------------- */

    errorBox.textContent =
      '';


    errorBox.style.display =
      'none';



    /* ---------------------------------------------------------
       OPTIONS
    --------------------------------------------------------- */

    buildOptions();


    updateModal();



    /* ---------------------------------------------------------
       SHOW
    --------------------------------------------------------- */

    lastFocusedElement =
      document.activeElement;


    modal.hidden =
      false;


    document.body.style.overflow =
      'hidden';



    requestAnimationFrame(
      function () {

        closeButton.focus();

      }
    );

  }



  /* =========================================================
     CLOSE MODAL
  ========================================================= */

  function closeModal(force) {

    const forceClose =
      force === true;


    if (
      isAdding &&
      !forceClose
    ) {

      return;

    }



    modal.hidden =
      true;


    document.body.style.overflow =
      '';



    activeProduct =
      null;


    selectedOptions =
      [];


    sizeConversionRows =
      [];


    activeSizeRegion =
      'US';



    errorBox.textContent =
      '';


    errorBox.style.display =
      'none';



    if (
      lastFocusedElement &&
      typeof lastFocusedElement.focus
        === 'function'
    ) {

      try {

        lastFocusedElement.focus();

      } catch (error) {

        /* no action */

      }

    }

  }



  /* =========================================================
     PRODUCT IMAGE + QUICK ADD OPEN MODAL
  ========================================================= */

  root
    .querySelectorAll(
      '.khq-open-modal'
    )
    .forEach(
      function (trigger) {

        trigger.addEventListener(
          'click',
          function (event) {

            event.preventDefault();

            event.stopPropagation();


            openModal(
              trigger.dataset.productJson
            );

          }
        );

      }
    );



  /* =========================================================
     CLOSE EVENTS
  ========================================================= */

  closeButton.addEventListener(
    'click',
    function () {

      closeModal();

    }
  );


  backdrop.addEventListener(
    'click',
    function () {

      closeModal();

    }
  );


  document.addEventListener(
    'keydown',
    function (event) {

      if (
        event.key === 'Escape' &&
        !modal.hidden
      ) {

        closeModal();

      }

    }
  );



  /* =========================================================
     UPDATE CART ICON ONLY

     IMPORTANT:
     This does NOT open cart drawer.
     This does NOT redirect.
     This does NOT reload current page.
  ========================================================= */

  async function refreshCartIcon() {

    try {

      const sectionURL =
        window.location.pathname +
        '?sections=cart-icon-bubble';


      const response =
        await fetch(
          sectionURL,
          {
            method: 'GET',
            credentials: 'same-origin',
            headers: {
              'Accept': 'application/json'
            }
          }
        );


      if (!response.ok) {

        return;

      }


      const data =
        await response.json();


      if (
        !data ||
        !data['cart-icon-bubble']
      ) {

        return;

      }


      const wrapper =
        document.createElement(
          'div'
        );


      wrapper.innerHTML =
        data['cart-icon-bubble'];


      const newCartBubble =
        wrapper.querySelector(
          '#cart-icon-bubble'
        );


      const currentCartBubble =
        document.querySelector(
          '#cart-icon-bubble'
        );


      if (
        newCartBubble &&
        currentCartBubble
      ) {

        currentCartBubble.innerHTML =
          newCartBubble.innerHTML;

      }

    } catch (error) {

      /*
        Some themes do not have a
        cart-icon-bubble section.

        Ignore silently.
      */

    }

  }



  /* =========================================================
     ADD TO CART

     NO REDIRECT
     NO CART DRAWER
     NO PAGE REFRESH
  ========================================================= */

  async function addCurrentVariantToCart() {

    if (
      isAdding ||
      !activeProduct
    ) {

      return;

    }



    const variant =
      getCurrentVariant();



    if (
      !variant ||
      !variant.available
    ) {

      return;

    }



    /* ---------------------------------------------------------
       LOADING
    --------------------------------------------------------- */

    isAdding =
      true;


    addButton.disabled =
      true;


    addText.textContent =
      'ADDING...';


    errorBox.textContent =
      '';


    errorBox.style.display =
      'none';



    try {


      /* -------------------------------------------------------
         SHOPIFY ROOT
      ------------------------------------------------------- */

      const shopifyRoot =
        (
          window.Shopify &&
          window.Shopify.routes &&
          window.Shopify.routes.root
        )
          ? window.Shopify.routes.root
          : '/';



      /* -------------------------------------------------------
         AJAX ADD

         IMPORTANT:

         No form submit.
         No window.location.
         No redirect.
         No cart drawer event.
      ------------------------------------------------------- */

      const response =
        await fetch(
          shopifyRoot + 'cart/add.js',
          {

            method: 'POST',

            headers: {

              'Content-Type':
                'application/json',

              'Accept':
                'application/json'

            },

            body:
              JSON.stringify(
                {

                  items: [

                    {

                      id:
                        Number(
                          variant.id
                        ),

                      quantity:
                        1

                    }

                  ]

                }
              )

          }
        );



      const result =
        await response.json();



      /* -------------------------------------------------------
         ERROR FROM SHOPIFY
      ------------------------------------------------------- */

      if (!response.ok) {

        throw new Error(

          result.description

          ||

          result.message

          ||

          'Unable to add this item to the cart.'

        );

      }



      /* -------------------------------------------------------
         SUCCESS
      ------------------------------------------------------- */

      addText.textContent =
        'ADDED ✓';



      /*
        Only try to update the cart badge.

        Do NOT:
        renderer.open()
        cartDrawer.open()
        cart:refresh
        window.location
        window.location.reload()
      */

      await refreshCartIcon();



      /* -------------------------------------------------------
         CLOSE QUICK ADD

         Keep customer on current product page.
      ------------------------------------------------------- */

      window.setTimeout(
        function () {

          isAdding =
            false;


          closeModal(
            true
          );


          addText.textContent =
            'ADD TO CART';


          addButton.disabled =
            false;

        },
        700
      );


    } catch (error) {


      isAdding =
        false;


      addButton.disabled =
        false;


      addText.textContent =
        'ADD TO CART';



      errorBox.textContent =
        (
          error &&
          error.message
        )
          ? error.message
          : 'Unable to add this item. Please try again.';


      errorBox.style.display =
        'block';

    }

  }



  /* =========================================================
     ADD BUTTON
  ========================================================= */

  addButton.addEventListener(
    'click',
    function (event) {

      /*
        Prevent accidental Shopify
        form submission or navigation.
      */

      event.preventDefault();

      event.stopPropagation();


      addCurrentVariantToCart();

    }
  );


})();